import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";
import ProjectsPage from "./pages/ProjectsPage";
import CreateProjectPage from "./pages/CreateProjectPage";
import ContactInfoPage from "./pages/ContactInfoPage";
import AboutUsPage from "./pages/AboutUsPage";
import DigitalGuidePage from "./pages/DigitalGuidePage";
import TestimonialsPage from "./pages/TestimonialsPage";
import CreateTestimonialPage from "./pages/CreateTestimonialPage";

export default function App() {
	return (
		<Routes>
			<Route path="/login" element={<LoginPage />} />

			<Route
				element={
					<PrivateRoute>
						<Layout />
					</PrivateRoute>
				}
			>
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/dashboard/projects" element={<ProjectsPage />} />
				<Route path="/dashboard/projects/create" element={<CreateProjectPage />} />
				<Route path="/dashboard/projects/edit/:id" element={<CreateProjectPage />} />
				<Route path="/dashboard/about-us" element={<AboutUsPage />} />
				<Route path="/dashboard/contact-info" element={<ContactInfoPage />} />
				<Route path="/dashboard/digital-guide" element={<DigitalGuidePage />} />
				<Route path="/dashboard/testimonials" element={<TestimonialsPage />} />
				<Route path="/dashboard/testimonials/create" element={<CreateTestimonialPage />} />
				<Route path="/dashboard/testimonials/edit/:id" element={<CreateTestimonialPage />} />
			</Route>

			{/* Редирект на логин по умолчанию */}
			<Route path="*" element={<LoginPage />} />
		</Routes>
	);
}
